import script from "./SummaryCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SummaryCard.vue?vue&type=script&lang=ts&setup=true"

import "./SummaryCard.vue?vue&type=style&index=0&id=12818782&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12818782"]])

export default __exports__